import { Box, SxProps, TextField, Theme } from '@mui/material'
import React from 'react'
import ColumnEnum from '../utils/columEnum'
import FilterPanelSelect from './PanelSelect'
import { useThemeStore } from 'global/components/ToggleTheme'
import { GridFilterItemPro, GridFilterModelPro } from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'
import localeText from '@/locales/datagrid'

export default function FieldValue({
    column,
    onFilterModelChange,
    item,
    sx,
}: {
    column: GridColDefPro
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    sx?: SxProps<Theme>
}) {
    const theme = useThemeStore(state => state.theme)
    const props = {
        label: localeText.filterPanelValue,
        variant: 'outlined' as const,
        size: 'small' as const,
        defaultValue: item.value,
        sx: sx,
        autoComplete: 'off',
        onChange: (e: any) => {
            onFilterModelChange(prev => ({
                ...prev,
                items: prev.items.map(p =>
                    p.id === item.id
                        ? {
                              ...p,
                              value: e.target.value,
                          }
                        : p,
                ),
            }))
        },
    }

    return React.useMemo(() => {
        if (!item.operatorValue) return <Box sx={sx}></Box>
        else if (['isEmpty', 'isNotEmpty'].includes(item.operatorValue))
            return <Box sx={sx}></Box>
        else if (['SN', 'boolean'].includes(String(column.type)))
            return (
                <FilterPanelSelect
                    {...props}
                    options={[
                        {
                            label: localeText.filterPanelValueYes,
                            value: column.type === 'SN' ? 'S' : 'true',
                        },
                        {
                            label: localeText.filterPanelValueNo,
                            value: column.type === 'SN' ? 'N' : 'false',
                        },
                    ]}
                />
            )
        else if (ColumnEnum.isColumnEnum(column.type))
            return <FilterPanelSelect {...props} options={column.type.itens} />
        else
            return (
                <TextField
                    {...props}
                    sx={{
                        colorScheme: theme,
                        ...props.sx,
                    }}
                    type={column.type}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            )
    }, [item.operatorValue, column.type, theme])
}
